import { FirebaseWatsonObservableService } from '../firebase-watson-observable.service';
import { Warehouse } from './warehouse.dto';
import { FirebaseObservableServiceFactory } from '@damofire/data-angular-commons';
import { ChangeTyped, WW_WAREHOUSES_COLLECTION } from '@damofire/data-commons';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class WarehouseObservableService {
  abstract observeWarehouse(id: string): Observable<ChangeTyped<Warehouse>>;
}

@Injectable()
export class FirebaseWarehouseObservableService extends WarehouseObservableService {
  private readonly firebaseWatsonObservableService: FirebaseWatsonObservableService<Warehouse>;

  constructor(private readonly firebaseObservableServiceFactory: FirebaseObservableServiceFactory) {
    super();
    this.firebaseWatsonObservableService = new FirebaseWatsonObservableService<Warehouse>(firebaseObservableServiceFactory, WW_WAREHOUSES_COLLECTION);
  }

  observeWarehouse(id: string): Observable<ChangeTyped<Warehouse>> {
    return this.firebaseWatsonObservableService.observeDoc(id);
  }
}
